import React from 'react';

/**
 * A custom React hook that returns the current `window` and `document` objects if they are
 * available. Returns `null` if not in a browser environment.
 *
 * @since 8.8.0
 */
function useBrowser() {
  const [win, setWin] = React.useState(null);
  const [doc, setDoc] = React.useState(null);
  React.useEffect(() => {
    if (typeof window !== 'undefined') {
      setWin(window);
    }
    if (typeof document !== 'undefined') {
      setDoc(document);
    }
  }, []);
  return [win, doc];
}

export { useBrowser };
